import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './campaign_title.less'
import { getI18n } from 'client/i18n'
import Avatar from 'components/common/avatar'

const i18n = getI18n('components/campaign_title')

class CampaignTitle extends React.Component {
  static propTypes = {
    campaignId: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isOwner: PropTypes.bool.isRequired,
  }

  render() {
    return (
      <div styleName="container">
        <div styleName="avatar-wrapper">
          <Avatar
            showInitials={true}
            glow={false}
            campaignId={this.props.campaignId}
          />
        </div>
        <div styleName="title-wrapper">
          <div styleName="title">{this.props.title}</div>
          <div styleName="intro">
            {i18n('intro_default', { name: this.props.displayName })}
            {this.props.isOwner && (
              <span styleName="organizer-subtext">
                &nbsp;
                {i18n('organizer_subtext')}
              </span>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default cssModules(CampaignTitle, styles)
